import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import "antd/dist/reset.css";
import "./styles/tokens.css";
import "./styles/components.css";
import App from "./App";
import { cognitoEnabled, oidcConfig } from "./lib/auth";

// Mount the OIDC provider only when Cognito is configured; local dev runs open.
const app = <App />;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {cognitoEnabled ? <AuthProvider {...oidcConfig}>{app}</AuthProvider> : app}
  </React.StrictMode>,
);
